module.exports = __webpack_public_path__ + "static/media/btn-facebook.c64372a4.svg";